import { ModulosMotivoENUM, TipoEmpleadoEnumChoice } from '@/shared';
import ComentariosBitacoraDialog from '@/shared/components/ui/ComentariosBitacoraDialog/ComentariosBitacoraDialog';
import BitacoraDialog from '@/shared/components/ui/CrearBitacoraDialog/CrearBitacoraDialog';
import { useDiccionarioMotivo } from '@/store/erp/diccionario_motivo/diccionario_motivo.store';
import { useCategoriaProductoStore } from '@/store/erp';
import { userPromocionesStore } from '@/store/erp/promociones';
import { usePaymentMethodsStore } from '@/store/erp/system-settings/payment-methods';
import { usePlanStore } from '@/store/erp/system-settings/plan.store';
import { useTypeInstalation } from '@/store/erp/system-settings/type-instalation';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useEmpleadoStore } from '@/store/erp/empleado';
export type SaleModuleProps = {};

const SaleModule: React.FC<SaleModuleProps> = () => {

  const getPromociones = userPromocionesStore(s => s.getPromociones);
  const getpaymentMethodsFilterPaging = usePaymentMethodsStore(s => s.getpaymentMethodsFilterPaging);
  const getPlans = usePlanStore(s => s.getPlans);
  const getTypeInstalation = useTypeInstalation(s => s.getTypeInstalation);
  const emitRegistrarUsuario = useDiccionarioMotivo().emitRegistrarUsuario
  const setDepartamento = useDiccionarioMotivo().setDepartamento
  const getCategoriaProducto = useCategoriaProductoStore(s => s.getCategoriaProducto);
  const getEmpleadoByAll = useEmpleadoStore(s => s.getEmpleadoByAll);


  /* const {
    newPrivateMessage,
    isConnected
  } = useSocketBitacoraStore();


  useEffect(() => {
    if (isConnected) {
      console.log('escuchar mensajes privados');
      newPrivateMessage()
    }

  }, [isConnected]) */

  useEffect(() => {
    setDepartamento(ModulosMotivoENUM.BITACORA_VENTA)
    emitRegistrarUsuario()
  }, [])

  useEffect(() => {

    (async () => {
      const results = await Promise.allSettled([
        getPromociones(),
        getPlans({
          page_size: 300,
          estado: true,
        }),
        getTypeInstalation({
          page_size: 600,
          estado: true
        }),
        getpaymentMethodsFilterPaging({
          page_size: 600,
          estado: true,
          aplica_home: true
        }),
        getEmpleadoByAll({
          tipo_empleado: TipoEmpleadoEnumChoice.VENDEDOR,
          estado: true,
          page_size: 600,
        }),
        getCategoriaProducto({
          page_size: 600,
          estado: true
        }),
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);

  return (
    <>
      <Outlet />
      <ComentariosBitacoraDialog />
      <BitacoraDialog />
    </>
  );
};

export default SaleModule;
